import type { NativeChromeType } from "#public"

// A tab has no window chrome to replace — the browser's own is above the page
// and out of reach. Undefined is the whole implementation, and the app's
// titlebar never renders.
export const NativeChrome: NativeChromeType = () => undefined
